export default [
  {
    path: "/foundation/introduceManage",
    component: () =>
      import("@/pages/brandsManage/foundation/introduceManage.vue"),
    name: "introduceManage",
    title: "展示信息配置",
    meta: {
      title: "展示信息配置"
    }
  },
  {
    path: "/foundation/groupManage",
    component: () => import("@/pages/brandsManage/foundation/groupManage.vue"),
    name: "groupManage",
    title: "分组信息配置",
    meta: {
      title: "分组信息配置"
    }
  },
  {
    path: "/foundation/signRecord",
    component: () => import("@/pages/brandsManage/foundation/signRecord.vue"),
    name: "signRecord",
    title: "签到记录",
    meta: {
      title: "签到记录"
    }
  },
  {
    path: "/foundation/apply",
    component: () => import("@/pages/brandsManage/foundation/apply.vue"),
    name: "volunteerApply",
    title: "志愿者申请表",
    meta: {
      title: "志愿者申请表"
    }
  }
];
